import { DEFAULT_TEXTURE_SETTINGS } from '../constants'

export const initialTextureSettingsState = {
  textureSettings: { ...DEFAULT_TEXTURE_SETTINGS },
}

